import {
  Box,
  Grid,
  Hidden,
  InputAdornment,
  Typography,
} from "@material-ui/core";
import { Formik } from "formik";
import FormAutoComplete from "../../../../forms/formik/FormSelectField";
import FormTextInput from "../../../../forms/formik/FormTextInput";
import ScrollToFirstError from "../../../../forms/formik/ScrollToFirstError";
import useNewPurchase, { validationSchema } from "./useNewPurchase";
import SubmitButton from "../../../../forms/formik/FormSubmitButton";
import CustomButton from "../../../../forms/CustomButton";
import InvestorDetailsPreview from "../../InvestorDetails";
import { convertToInr } from "../../../../../utils/cart";
import FormCheckbox from "../../../../forms/formik/FormCheckbox";
import { YES } from "../../../../../store/types";
import { Fragment } from "react";
import { FAMILY_OPTIONS } from "..";
import {
  maskEmail,
  maskMobileNumber,
  maskPan,
} from "../../../../../utils/utilityFunctions";

export default function NewPurchase() {
  const {
    cancelTransaction,
    isEditTransaction,
    handleCategoryChange,
    handleSchemeChange,
    handleComboSwitch,
    onSubmit,
    options,
    payload,
    initialValues,
  } = useNewPurchase();

  return (
    <Grid container>
      <Grid item lg={9} sm={12}>
        <Box
          sx={{
            margin: "40px",
            marginRight: "10px",
            bgcolor: "white",
            padding: "18px 24px 18px 24px",
            boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
            borderRadius: "4px",
          }}
        >
          <Formik
            onSubmit={onSubmit}
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnChange
            enableReinitialize
          >
            {({ values, setValues, handleSubmit }) => (
              <Box component="form" onSubmit={handleSubmit}>
                <ScrollToFirstError />
                <Typography
                  component="h4"
                  style={{
                    fontWeight: "800",
                    fontSize: "24px",
                    marginBottom: "20px",
                    fontFamily: "OpenSans-SemiBold",
                  }}
                >
                  New Purchase
                </Typography>

                <FormAutoComplete
                  name="amc"
                  label="AMC"
                  placeholder="Select AMC"
                  options={options.funds}
                  disabled
                />
                <FormAutoComplete
                  name="category"
                  label="Category"
                  placeholder="Select Category"
                  options={options.categoryOptions}
                  onChange={handleCategoryChange(values, setValues)}
                />
                <FormAutoComplete
                  name="scheme"
                  label="Scheme"
                  placeholder="Select Scheme"
                  options={options.schemeOptions}
                  onChange={handleSchemeChange(values, setValues)}
                />
                {(() => {
                  const selectedScheme = options.schemeOptions.find(
                    (scheme) => scheme.value === values.scheme
                  );

                  return (
                    selectedScheme &&
                    selectedScheme.combo_flag === YES && (
                      <Fragment>
                        <FormCheckbox
                          label="Purchase Cum Switch"
                          name="combo"
                          onChange={handleComboSwitch(values, setValues)}
                          // onClick={handleCombo}
                        />
                        <div
                          style={{
                            color: "#283d7c",
                            fontSize: 14,
                            fontFamily: "OpenSans-SemiBold",
                            margin: 10,
                          }}
                        >
                          {selectedScheme.combo_disclaimer}
                        </div>
                      </Fragment>
                    )
                  );
                })()}
                <FormTextInput
                  name="amount"
                  label={
                    values.minAmount
                      ? `Investment Amount (Minimum ${convertToInr(
                          values.minAmount
                        )})`
                      : "Investment Amount"
                  }
                  placeholder="Enter Investment Amount"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {"\u20B9"}
                      </InputAdornment>
                    ),
                  }}
                  type="number"
                />
                <Box display="flex">
                  <CustomButton
                    label="Go To Cart"
                    variant="outlined"
                    onClick={cancelTransaction}
                  />
                  <SubmitButton
                    label={isEditTransaction ? "Update" : "Add to Cart"}
                    variant="contained"
                  />
                </Box>
              </Box>
            )}
          </Formik>
        </Box>
      </Grid>
      <Hidden mdDown>
        <Grid item lg={3}>
          <InvestorDetailsPreview
            investorData={[
              { label: "Investor Name", value: payload.investorName },
              { label: "PAN", value: maskPan(payload.pan) },
              { label: "Email", value: maskEmail(payload.email) },
              {
                label: "Email family Description",
                value: FAMILY_OPTIONS.find(
                  ({ value }) => payload.familyEmailFlag === value
                ).label,
              },
              { label: "Mobile", value: maskMobileNumber(payload.mobile) },
              {
                label: "Mobile family Description",
                value: FAMILY_OPTIONS.find(
                  ({ value }) => payload.familyMobileFlag === value
                ).label,
              },
              {
                label: "Investor Category",
                value:
                  payload.invCategory === "11"
                    ? "Resident Indian"
                    : payload.invCategory === "20"
                    ? "NRI"
                    : "",
              },
              { label: "ARN Code", value: payload.arnCode },
              { label: "Sub-ARN Code", value: payload.subArn },
              { label: "Sub-Broker Code", value: payload.subBroker },
              {
                label: "EUIN Declaration",
                value: payload.euinDeclaration === "N" ? "Yes" : "No",
              },
            ]}
          />
        </Grid>
      </Hidden>
    </Grid>
  );
}
